import React, { Component } from 'react';
import './Messenger.css';

class Messenger extends Component {
    state = {
        isOpen: false,
        message: ''
    };

    toggleChat = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    handleMessageChange = (e) => {
        this.setState({ message: e.target.value });
    };

    handleSendMessage = (e) => {
        e.preventDefault();
        const { pageId } = this.props;
        const { message } = this.state;
        
        const textToSend = message.trim() || 'Hi! I need help with eSIM.';
        const messengerUrl = `https://m.me/${pageId}?text=${encodeURIComponent(textToSend)}`;
        window.open(messengerUrl, '_blank', 'width=400,height=600');
        
        this.setState({ message: '' });
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            this.handleSendMessage(e);
        }
    };

    render() {
        const { 
            themeColor = '#0084ff',
            loggedOutGreeting = 'Hi! Need help with eSIM? Chat with us!'
        } = this.props;
        
        const { isOpen, message } = this.state;

        return (
            <div className="messenger-widget">
                {/* Chat Box */}
                {isOpen && (
                    <div className="messenger-chat-box">
                        {/* Header */}
                        <div className="messenger-header" style={{ backgroundColor: themeColor }}>
                            <div className="messenger-header-content">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                                    <path d="M12 2C6.477 2 2 6.145 2 11.243c0 2.896 1.437 5.482 3.688 7.186V22l3.451-1.897c.921.253 1.899.388 2.911.388 5.523 0 10-4.145 10-9.243C22 6.145 17.523 2 12 2zm.945 12.44l-2.567-2.739-5.01 2.74L10.65 9.56l2.627 2.738 4.952-2.738-5.284 4.88z"/>
                                </svg>
                                <span className="messenger-title">Seafarer Internet Service</span>
                            </div>
                            <button 
                                className="messenger-close-btn" 
                                onClick={this.toggleChat}
                            >
                                ✕
                            </button>
                        </div>

                        {/* Body */}
                        <div className="messenger-body">
                            <div className="messenger-greeting">
                                <div className="messenger-avatar" style={{ backgroundColor: themeColor }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                                        <path d="M12 2C6.477 2 2 6.145 2 11.243c0 2.896 1.437 5.482 3.688 7.186V22l3.451-1.897c.921.253 1.899.388 2.911.388 5.523 0 10-4.145 10-9.243C22 6.145 17.523 2 12 2zm.945 12.44l-2.567-2.739-5.01 2.74L10.65 9.56l2.627 2.738 4.952-2.738-5.284 4.88z"/>
                                    </svg>
                                </div>
                                <div className="messenger-greeting-text">
                                    {loggedOutGreeting}
                                </div>
                            </div>
                            <div className="messenger-info-text">
                                Type your message below and we'll continue in Messenger
                            </div>
                        </div>

                        {/* Input Area */}
                        <form className="messenger-input-area" onSubmit={this.handleSendMessage}>
                            <input
                                type="text"
                                className="messenger-input"
                                placeholder="Type a message..."
                                value={message}
                                onChange={this.handleMessageChange}
                                onKeyPress={this.handleKeyPress}
                            />
                            <button 
                                type="submit" 
                                className="messenger-send-btn"
                                style={{ color: themeColor }}
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                                </svg>
                            </button>
                        </form>
                    </div>
                )}

                {/* Float Button */}
                {!isOpen && (
                    <button 
                        className="messenger-float-btn"
                        style={{ backgroundColor: themeColor }}
                        onClick={this.toggleChat}
                    >
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
                            <path d="M12 2C6.477 2 2 6.145 2 11.243c0 2.896 1.437 5.482 3.688 7.186V22l3.451-1.897c.921.253 1.899.388 2.911.388 5.523 0 10-4.145 10-9.243C22 6.145 17.523 2 12 2zm.945 12.44l-2.567-2.739-5.01 2.74L10.65 9.56l2.627 2.738 4.952-2.738-5.284 4.88z"/>
                        </svg>
                    </button>
                )}
            </div>
        );
    }
}

export default Messenger;